import React, { useEffect, useState } from 'react';
import { Brain, Save, Check } from 'lucide-react';
import apiClient from '../lib/apiClient';
import storage from '../lib/storage';
import './TrainAI.css';

function TrainAI() {
  const [form, setForm] = useState({
    business_name: '',
    niche: '',
    description: '',
    tone: 'profissional',
    target_audience: '',
    keywords: '',
    unique_value: '',
    logo_url: ''
  });
  const [loading, setLoading] = useState(false);
  const [configured, setConfigured] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await apiClient.request('/user/business-context');
        if (data?.success && data.business_context) {
          const context = data.business_context;
          setForm({
            business_name: context.business_name || '',
            niche: context.niche || '',
            description: context.description || '',
            tone: context.tone || 'profissional',
            target_audience: context.target_audience || '',
            keywords: Array.isArray(context.keywords) ? context.keywords.join(', ') : (context.keywords || ''),
            unique_value: context.unique_value || '',
            logo_url: context.logo_url || ''
          });
          setConfigured(Boolean(data.is_configured));
        }
      } catch (error) {
        console.error('Erro ao carregar contexto:', error);
      }
    };
    load();
  }, []);

  const uploadLogo = async (file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append('logo', file);

    try {
      const data = await apiClient.request('/user/upload-logo', { method: 'POST', body: formData });
      if (data?.success) {
        setForm((prev) => ({ ...prev, logo_url: data.logo_url || '' }));
      }
    } catch (error) {
      console.error('Erro ao enviar logo:', error);
    }
  };

  const save = async () => {
    if (!form.business_name.trim()) {
      alert('Informe o nome do negócio.');
      return;
    }

    setLoading(true);
    try {
      const data = await apiClient.request('/user/business-context', {
        method: 'POST',
        body: JSON.stringify({
          ...form,
          keywords: form.keywords.split(',').map((item) => item.trim()).filter(Boolean)
        })
      });

      if (data?.success) {
        setConfigured(true);
        if (data.energy !== undefined) {
          storage.set('userEnergy', String(data.energy));
          window.dispatchEvent(new CustomEvent('energyUpdated', { detail: { energy: data.energy } }));
        }
      }
    } catch (error) {
      console.error('Erro ao salvar contexto:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="train-ai-page">
      <div className="ai-header">
        <div className={`status-badge ${configured ? 'active' : 'pending'}`}>
          {configured ? <Check size={14} /> : <Brain size={14} />}
          {configured ? 'Configurada' : 'Pendente'}
        </div>
      </div>

      <section className="card ai-card">
        <div className="input-group">
          <label>Nome do negócio</label>
          <input value={form.business_name} onChange={(event) => setForm((prev) => ({ ...prev, business_name: event.target.value }))} />
        </div>
        <div className="input-group">
          <label>Nicho</label>
          <input value={form.niche} onChange={(event) => setForm((prev) => ({ ...prev, niche: event.target.value }))} />
        </div>
        <div className="input-group">
          <label>Descrição</label>
          <textarea rows={4} value={form.description} onChange={(event) => setForm((prev) => ({ ...prev, description: event.target.value }))} />
        </div>
        <div className="input-group">
          <label>Palavras-chave</label>
          <input value={form.keywords} onChange={(event) => setForm((prev) => ({ ...prev, keywords: event.target.value }))} />
        </div>
        <div className="input-group">
          <label>Logo</label>
          <input type="file" accept="image/*" onChange={(event) => uploadLogo(event.target.files?.[0])} />
          {form.logo_url && <p>Logo enviada com sucesso.</p>}
        </div>

        <button className="btn btn-outline" onClick={save} disabled={loading}>
          <div className="blob1"></div>
          <div className="blob2"></div>
          <div className="inner"><Save size={16} /> {loading ? 'Salvando...' : 'Salvar Treinamento'}</div>
        </button>
      </section>
    </div>
  );
}

export default TrainAI;
